import React, { useState } from 'react';
import {
  BuildersComponentsTrackingProvider,
  Button,
  Modal,
  Text,
  Title
} from '@gjensidige/builders-components';
import { Close } from '@gjensidige/builders-icons';
import { TrackingOptions, TrackingProvider } from '@gjensidige/core-analytics';

import './AbortPurchase.scss';

interface Props {
  primaryActionText: string;
  secondaryActionText: string;
  messageText: string;
  headerText: string;
  toggleButtonText: string;
  handleSecondaryAction: () => void;
  trackingObject?: { options: TrackingOptions };
}
export type AbortPurchaseProps = Props;
export function AbortPurchase(props: AbortPurchaseProps) {
  const {
    primaryActionText,
    secondaryActionText,
    messageText,
    headerText,
    toggleButtonText,
    handleSecondaryAction
  } = props;

  const [visible, setVisible] = useState<boolean>(false);
  const onClick = () => {
    setVisible(!visible);
  };

  const renderAbortModal = () => {
    return (
      <>
        <div>
          <Button
            variant="action"
            icon={<Close />}
            onClick={onClick}
            data-testid="toggle-button"
            className="navigation-button"
          >
            {toggleButtonText}
          </Button>
        </div>
        <Modal
          aria-label="Avbryt köp"
          open={visible}
          strict={false}
          closeLabel="Fortsätt köp"
          onClose={() => setVisible(false)}
          className="abort-purchase-modal"
        >
          <div data-testid="content" className="text-content">
            <Title as="h2" size="4">
              {headerText}
            </Title>
            <Text size="body" className="message-text">
              {messageText}
            </Text>
          </div>
          <div className="modal-btn-container">
            <Button
              variant="secondary"
              onClick={handleSecondaryAction}
              data-testid="toggle-button"
            >
              {secondaryActionText}
            </Button>
            <Button variant="primary" onClick={onClick}>
              {primaryActionText}
            </Button>
          </div>
        </Modal>
      </>
    );
  };

  return props.trackingObject && props.trackingObject?.options ? (
    <BuildersComponentsTrackingProvider options={props.trackingObject?.options}>
      <TrackingProvider options={props.trackingObject?.options}>
        {renderAbortModal()}
      </TrackingProvider>
    </BuildersComponentsTrackingProvider>
  ) : (
    renderAbortModal()
  );
}
